import { CrosswordCell, Clue } from "@/utils/crosswordGenerator";

export interface LocationState {
  grid: CrosswordCell[][];
  acrossClues: Clue[];
  downClues: Clue[];
  title?: string;
  uuid?: string;
}

export interface crosswordUiCell {
  currValue: string,
  answer: string,
  number: number,
  isAcross: boolean,
  isDown: boolean,
  acrossClue: number,
  downClue: number,
  isRevealed: boolean,
  isIncorrect: boolean,
}

export interface UiClue {
  number: number;
  clue: string;
  row: number;
  col: number;
}

export const crossWordGridToUiGrid = (grid: CrosswordCell[][]) => {
  return grid.map((row) => row.map((cell) => ({
    currValue: '',
    answer: cell.answer || '',
    number: cell.number || 0,
    isAcross: false,
    isDown: false,
    acrossClue: 0,
    downClue: 0,
    isRevealed: false,
    isIncorrect: false,
  })));
}

export const findClueForCell = (clue: Clue, grid: crosswordUiCell[][]) => {
  for (let i = 0; i < grid.length; i++) {
    for (let j = 0; j < grid[i].length; j++) {
      if (grid[i][j].number == clue.number) {
        return { row: i, col: j };
      }
    }
  }
  return null;
}

export const crossWordCluesToUiClues = (clues: Clue[], grid: crosswordUiCell[][], direction: 'across' | 'down') => {
  let uiClues: UiClue[] = [];
  let addedNums = new Set<number>();

  for( let i = 0; i < clues.length; i++) {
    if(addedNums.has(clues[i].number)) {
      continue;
    }
    const position = findClueForCell(clues[i], grid);
    if (position) {
      let col = position.col;
      let row = position.row;
      let num = clues[i].number;
      uiClues.push({
        number: num,
        clue: clues[i].clue,
        row: row,
        col: col,
      });
      addedNums.add(num);

      if(direction === 'across') {
        while(col < grid[0].length && grid[row][col].answer != '') {
          grid[row][col].isAcross = true;
          grid[row][col].acrossClue = num;
          col++;
        }
      }
      else {
        while(row < grid.length && grid[row][col].answer != '') {
          grid[row][col].isDown = true;
          grid[row][col].downClue = num;
          row++;
        }
     }
    }
  }
  return uiClues;
}

export const shiftCluesDown = (grid: crosswordUiCell[][], acrossClues: UiClue[], downClues: UiClue[]) => {
  let map = new Map<number, number>();
  let count = 1;

  for(let i = 0; i < grid.length; i++) {
    for(let j = 0; j < grid[i].length; j++) {
      if(grid[i][j].number != 0) {
        map.set(grid[i][j].number, count);
        grid[i][j].number = count;
        count++;
      }
    }
  }

  for(let i = 0; i < acrossClues.length; i++) {
    acrossClues[i].number = map.get(acrossClues[i].number) || acrossClues[i].number;
  }
  acrossClues.sort((a, b) => a.number - b.number);
  for(let i = 0; i < downClues.length; i++) {
    downClues[i].number = map.get(downClues[i].number) || downClues[i].number;
  }
  downClues.sort((a, b) => a.number - b.number);

  for(let i = 0; i < grid.length; i++) {
    for(let j = 0; j < grid[i].length; j++) {
      if(grid[i][j].acrossClue != 0) {
        grid[i][j].acrossClue = map.get(grid[i][j].acrossClue) || grid[i][j].acrossClue;
      }
      if(grid[i][j].downClue != 0) {
        grid[i][j].downClue = map.get(grid[i][j].downClue) || grid[i][j].downClue;
      }
    }
  }
} 